import React, {useState} from 'react';
import styles from './HeaderButtons.module.css';
import RecommendationModal from '../RecommendationModal';
import {SubUser} from "../../../../services/models/sub_user";
import {useCreateRecom} from "../../../../hooks/useQuery/useCreateRecom";
import {useDeleteRecom} from "../../../../hooks/useQuery/useDeleteRecom";
import {useParams} from "react-router-dom";
import sButtons from "../../../../assets/styles/buttons.module.css";
import {SearchInput} from '../../../../components/SearchInput/SearchInput';

interface HeaderButtonsProps {
    subUsersSectorData?: Partial<SubUser>[] | undefined;
    searchValue?: string;
    onSearchChange?: (value: string) => void;
}


export const HeaderButtons: React.FC<HeaderButtonsProps> = ({
    subUsersSectorData,
    searchValue = '',
    onSearchChange
}) => {
    const [showModal, setShowModal] = useState(false);
    const {sectorId} = useParams();
    const {mutate: createRecom} = useCreateRecom();
    const {mutate: deleteRecom} = useDeleteRecom(sectorId as string);


    const handleDelete = (id: string) => {
        deleteRecom(id, {
            onSuccess: () => setShowModal(false)
        });
    };

    const handleSave = (data: any, file: File | null) => {
        createRecom({data: {...data, file}}, {
            onSuccess: () => setShowModal(false)
        });
    };


    return (
        <>
            <RecommendationModal
                show={showModal}
                onClose={() => setShowModal(false)}
                onSave={handleSave}
                isEdit={false}
                subUsersSectorData={subUsersSectorData}
                onDelete={handleDelete}
            />
            <div className={styles.buttonsContainer}>
                <SearchInput
                    value={searchValue}
                    onChange={onSearchChange || (() => {})}
                    placeholder="Поиск по названию рекомендации"
                />
                <button
                    className={`${sButtons.iconButton} ${sButtons.addButton}`}
                    onClick={() => setShowModal(true)}>
                    Добавить рекомендацию
                </button>
            </div>
        </>
    );
};
